export default __webpack_public_path__ + "static/media/close.a9b9583d.svg";